<!-- Please keep the app.component clean -->
<router-outlet></router-outlet>
<!-- <app-footer [contactLookup]="contactLookup"></app-footer>  -->